<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-field class="align-items-center" :class="{ 'md-invalid': errMsg }">
          <label>Enter your Mobile or Email</label>
          <md-input
            ref="textInput"
            v-model="emailOrPhone"
            type="text"
            @keyup.enter="enterPressed"
          />
          <md-button
            class="md-primary"
            :disabled="disabled"
            @click="requestCode"
            >Continue</md-button
          >
          <span v-if="countDown < 10" class="md-helper-text"
            >You can request another code in {{ countDown }} seconds</span
          >
          <span class="md-error">{{ errMsg }}</span>
        </md-field>
        <md-button
          v-if="!canGetOTP"
          to="/registration"
          class="md-raised md-success"
          >Register</md-button
        >
      </div>
    </div>
    <div v-if="showCode === true" class="md-layout md-alignment-center-center">
      <div class="text-center my-3">
        Enter the 6-digit code sent to your mobile or email
        <v-otp-input
          input-classes="otp-input my-2"
          :num-inputs="6"
          separator=""
          :should-auto-focus="true"
          @on-complete="handleOnComplete"
          @on-change="handleOnChange"
        />
      </div>
      <div
        class="md-layout-item md-size-100 d-flex align-items-center justify-content-end"
      >
        <md-button
          class="md-raised md-success"
          :disabled="loading"
          @click="login()"
          >Login</md-button
        >
        <md-progress-spinner
          class="mx-3"
          :md-diameter="30"
          :md-stroke="loading ? 4 : 0"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>
    </div>
  </div>
</template>
<script>
import vOtpInput from "@bachdgvn/vue-otp-input";
import ApiService from "@/services/api";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "LoginForm",
  components: {
    vOtpInput,
  },
  mixins: [toastLaravelErrors],
  data() {
    return {
      emailOrPhone: "",
      showCode: false,
      disabled: false,
      canGetOTP: true,
      otp: null,
      countDown: 10,
      errMsg: "",
      loading: false,
    };
  },
  created() {
    ApiService.auth.setCSRF();
  },
  mounted() {
    this.$refs.textInput.$el.focus();

    if (this.$route.query.l) {
      this.emailOrPhone = this.$route.query.l;
      this.enterPressed();
    }
  },
  methods: {
    requestCode: function() {
      if (!this.canGetOTP) return;

      if (this.emailOrPhone.length === 0) return;

      if (this.countDown > 0) {
        // Send code
        if (!this.disabled) {
          this.errMsg = "";

          let data;

          if (/^\+?[0-9]+$/.test(this.emailOrPhone.replaceAll(" ", ""))) {
            // phone number entered
            data = {
              sms: this.emailOrPhone,
              mode: "sms",
            };
          } else {
            data = {
              email: this.emailOrPhone,
              mode: "email",
            };
          }

          // Disable
          this.disabled = true;

          ApiService.auth
            .generateOTP(data)
            .then((response) => {
              this.showCode = true;

              if (response.data.data.token) {
                this.otp = response.data.data.token;
                this.login();
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 404) {
                  // User not found
                  this.showCode = false;
                  // this.errMsg = "The email or mobile number was not found; please register.";
                  this.canGetOTP = false;
                  this.$router.push({
                    path: "/registration",
                    query: { d: this.emailOrPhone, t: data.mode },
                  });
                } else if (error.response.status === 406) {
                  // User not registered
                  this.showCode = false;
                  // this.errMsg = "Please complete registration.";
                  this.canGetOTP = false;
                  localStorage.user = JSON.stringify(
                    error.response.data.data.user
                  );
                  this.$router.push({
                    path: "/registration",
                  });
                } else {
                  this.errMsg = error.response.data.message;
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                this.errMsg = "An unknown error occurred.";
              } else {
                // Something happened in setting up the request that triggered an Error
                this.errMsg = "An unknown error occurred.";
              }

              this.disabled = error.response.status === 404;
            })
            .finally(() => {
              if (this.disabled) {
                setTimeout(() => {
                  if (this.canGetOTP) this.countDown -= 1;
                  this.requestCode();
                }, 1000);
              }
            });
        } else {
          // handle counting

          setTimeout(() => {
            if (this.canGetOTP) this.countDown -= 1;
            this.requestCode();
          }, 1000);
        }
      } else {
        this.disabled = false;
        this.countDown = 10;
      }
    },
    login() {
      if (this.otp.length !== 6) return;

      this.loading = true;

      let data;

      if (/^\+?[0-9]+$/.test(this.emailOrPhone.replaceAll(" ", ""))) {
        // phone number entered
        data = {
          sms: this.emailOrPhone,
          mode: "sms",
          otp_token: this.otp,
        };
      } else {
        data = {
          email: this.emailOrPhone,
          mode: "email",
          otp_token: this.otp,
        };
      }

      ApiService.auth
        .login(data)
        .then(() => {
          this.$store.dispatch("getAuthUser").then(() => {
            const user = this.$store.getters.authUser;
            if (user.business) {
              // User is in a business
              if (user.passes.count === 0) {
                // User has no valid passes
                this.$store.dispatch("setCart", [user]).then(() => {
                  this.$router.push("/cart");
                });
              } else {
                // User has valid passes
                if (
                  user.passes.every(
                    (pass) => pass.expires_at.slice(0, 4) === "2022"
                  )
                ) {
                  // Passes are from old system
                  if (user.business_manager) {
                    // User is a business manager
                    this.$router.push("/confirm-business");
                  } else {
                    // User is not a business manager
                    this.$store.dispatch("setCart", [user]).then(() => {
                      this.$router.push("/cart");
                    });
                  }
                } else {
                  // Passes are from new system
                  this.$router.push("/dashboard");
                }
              }
            } else {
              // User is not in a business
              this.$router.replace("/business-registration");
            }
          });
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.toastLaravelErrors(error);
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOnComplete(value) {
      this.otp = value;
      this.login();
    },
    handleOnChange(value) {
      this.otp = value;
    },
    enterPressed() {
      if (!this.disabled) {
        this.requestCode();
      }
    },
  },
};
</script>
<style></style>
